import React from "react";
import I18n from 'i18n.js.erb'
import { setImgTagWidth, setImgTagHeight } from "../../utils/utils";
import TextOverlayOnImage from "./TextOverlayOnImage";

const PlaceholderImage = ({size, overlaySize, additionalClasses, textOverlay, showNotGradableProductOverlay}) => {

  return (
    <div className="d-flex justify-content-center position-relative text-center"
         style={{ maxHeight: setImgTagHeight(size), maxWidth: setImgTagWidth(size) }}>
      <img
        src={window.location.origin + `/images/placeholder/${size}_placeholder.png`}
        alt=""
        className={`rounded ${additionalClasses ? additionalClasses : ''}`}
        height={setImgTagHeight(size)}
        width={setImgTagWidth(size)}
      />

      {
        showNotGradableProductOverlay ?
          <TextOverlayOnImage
            textOverlay={size !== 'thumb' ? I18n.t('js.common.notGradableProduct') : I18n.t('js.common.notGradableProductShort')}
            size={overlaySize ? overlaySize : size}
            type={'red-overlay'}
          />
        :
          textOverlay &&
            <TextOverlayOnImage
              textOverlay={"[" + textOverlay + "]"}
              size={overlaySize ? overlaySize : size}
              type={`gray-overlay${overlaySize === 'large' || size === 'large' ? '-large' : ''}`}
            />
      }
    </div>
  )
}

export default PlaceholderImage;